module.exports = __webpack_public_path__ + "static/img/weChat.3bdc26a0.jpg";